<template>
	<div>
		<div class="shop-focus-img">
			<slider animation="normal" :style="{ height: sliderHeight}">
		          <slider-item v-for="(i, index) in adsItems" :key="index">
		            <div>
		             <a :href='i.linkUrl'> <img :src='i.imgUrl' width="1400" height="370" /> </a>
		            </div>
		          </slider-item>
	        </slider>
		</div>
	</div>
</template>

<script>
	import { Slider, SliderItem } from '../../static/js/vue-easy-slider.js';
	export default {
		name: 'shopslider',
		data() {
			return {
				msg: 'Welcome to Your Vue.js App123',
				adsItems:[{linkUrl:'https://www.baidu.com',imgUrl:'../../static/images/temp/shop/focus-1.jpg'},
				{linkUrl:'https://www.baidu.com',imgUrl:'../../static/images/temp/shop/focus-1.jpg'},
				{linkUrl:'https://www.baidu.com',imgUrl:'../../static/images/temp/shop/focus-1.jpg'}],
				sliderHeight: '370px'
			}
		},
        components:{
        	Slider,
            SliderItem
    	}
	}
</script>


// WEBPACK FOOTER //
// src/components/ShopSlider.vue